/**
 * Readable text of a failed API call. `apiFetch` throws the raw response body, so the JSON error
 * envelope's message is unwrapped; plain-text errors and unknown values fall back.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  if (!(error instanceof Error) || !error.message) return fallback;
  try {
    const body: unknown = JSON.parse(error.message);
    if (
      typeof body === "object" && body !== null &&
      "error" in body && typeof body.error === "object" && body.error !== null &&
      "message" in body.error && typeof body.error.message === "string"
    ) {
      return body.error.message;
    }
  } catch {
    // The API may return a plain-text error.
  }
  return error.message;
}
